export default __webpack_public_path__ + "static/media/celebrate.b066cc47.svg";